import { Link } from 'react-router-dom';
import '../styles/epro.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Epro() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="epro-banner" className="epro-banner">
        <div
          className="m-auto banner-container"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="mb-32">
            <img src="./images/logo-epro.svg" alt="eprologoimage" className="epro-banner-img" />
          </div>
          <p
            className="fs-md fw-bold mb-24"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="100"
          >
            전자구매 업무 프로세스의 시스템화를 위한
            <br />
            e-Procurement 구축에 최적화된 EPRO
          </p>
          <p
            className="fs-base mb-60"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            구매 요청, 견적/입찰 관리, 발주, 계약까지
            <br />
            최적화된 구매 프로세스 정립을 제공합니다.
          </p>
          <ul
            className="epro-button"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <li>
              <Link to="/contact?service=epro&no=02" className="btn-outline fw-bold">
                소개자료 문의
              </Link>
            </li>
            <li>
              <Link to="/contact?service=epro&no=01" className="btn-filled fw-bold">
                서비스 도입 문의
              </Link>
            </li>
          </ul>
        </div>
      </section>
      <section id="epro-intro">
        <div className="m-auto content-padding">
          <h3 className="content-title">
            <strong>EPRO</strong>를 사용해야 하는 이유
          </h3>
          <div className="content-bg content-gap reason02-container">
            <div className="content-box epro-boxbar-x reason02-box">
              <ul>
                <li>
                  <img src="./images/ico-epro-reason01.svg" alt="epro 아이콘01" />
                  <p className="fs-base fw-md">
                    전사적 구매업무&nbsp;
                    <br className="mo-none" />
                    프로세스 정립
                  </p>
                  <p className="color-caption">
                    표준화 구매 프로세스와&nbsp;
                    <br className="mo-none" />
                    구매관련
                    <br className="pc-none" /> 기준 정보&nbsp;
                    <br className="mo-none" />
                    코드관리 제공
                  </p>
                </li>
                <li>
                  <img src="./images/ico-epro-reason02.svg" alt="epro 아이콘02" />
                  <p className="fs-base fw-md">
                    전자구매&nbsp;
                    <br className="mo-none" />
                    시스템 구축
                  </p>
                  <p className="color-caption">
                    전체 구매업무 통합과&nbsp;
                    <br className="mo-none" />
                    연관 시스템 연계로
                    <br />
                    통합적인 업무 관리
                  </p>
                </li>
                <li>
                  <img src="./images/ico-epro-reason03.svg" alt="epro 아이콘03" />
                  <p className="fs-base fw-md">
                    구매 협업&nbsp;
                    <br className="mo-none" />
                    기능 강화
                  </p>
                  <p className="color-caption">
                    내/외부 협업채널 강화로
                    <br />
                    운영조직과 고객과의&nbsp;
                    <br className="mo-none" />
                    원활한 정보 공유
                  </p>
                </li>
                <li>
                  <img src="./images/ico-epro-reason04.svg" alt="epro 아이콘04" />
                  <p className="fs-base fw-md">
                    쉽고 간편한&nbsp;
                    <br className="mo-none" />
                    계약 체결
                  </p>
                  <p className="color-caption">
                    전자문서화로 진행되어
                    <br />
                    신속한 업무 처리 및&nbsp;
                    <br className="mo-none" />
                    효율성 증대
                  </p>
                </li>
                <li>
                  <img src="./images/ico-epro-reason05.svg" alt="epro 아이콘05" />
                  <p className="fs-base fw-md">
                    강력한 보안과&nbsp;
                    <br className="mo-none" />
                    신뢰 제공
                  </p>
                  <p className="color-caption">
                    전자구매 신용평가를
                    <br />
                    통한 안전한 서비스&nbsp;
                    <br className="mo-none" />
                    운용 및 관리
                  </p>
                </li>
              </ul>
            </div>
            <div className="arrow">
              <img src="./images/epro-arrow.svg" alt="아래화살표" />
            </div>
            <div className="reason02-fin epro-reason02-fin fs-md fw-bold">
              고객 맞춤형 전자 구매솔루션 구축
            </div>
          </div>
          <h3 className="content-title02">
            <strong>EPRO</strong> 만의 특장점
          </h3>
          <p className="fs-md content-subtitle text-center">
            구매요청, 견적/입찰, 전자계약 체결, 협력사 관리, 사후관리까지&nbsp;
            <br className="mo-none" />
            전자구매 업무 전반에 걸친 원스탑 서비스
          </p>
          <div className="content-bg epro-strength-container">
            <div className="epro-strength-box01 content-box">
              <img className="logo-image" src="./images/logo-epro.svg" alt="epro logo image" />
              <div className="epro-blue-box fs-base">
                <strong>최신 UI/UX 기술이 반영</strong>된<br />
                수준 높은 구매시스템 구축
              </div>
              <div className="epro-blue-box fs-base">
                고객 요구를 반영한 개발/운영 구조
                <br />
                <strong>사용자 만족도 제고</strong>
              </div>
            </div>
            <div className="arrow">
              <img src="./images/epro-arrow.svg" alt="오른쪽화살표" />
            </div>
            <div className="epro-strength-content">
              <div className="epro-strength-box02 content-box epro-boxbar-y">
                <p className="color-primary fs-base fw-bold">최적의 구매 시스템 확보</p>
                <ul>
                  <li className="text-dot fs-base">최적화/유연성/확장가능한 업무 프로세스 확립</li>
                  <li className="text-dot fs-base">구매업무 담당자 간의 협업기능 강화</li>
                  <li className="text-dot fs-base">ERP 시스템과 연계한 업무 효율성 확보</li>
                </ul>
              </div>
              <div className="epro-strength-box02 content-box epro-boxbar-y">
                <p className="color-primary fs-base fw-bold">웹 개발 기술기반 확보</p>
                <ul>
                  <li className="text-dot fs-base">웹 표준 준수 및 개방형 기술기반 확보</li>
                  <li className="text-dot fs-base">
                    Desktop/Mobile 개발에 특화된 UXBooster 프레임워크
                  </li>
                  <li className="text-dot fs-base">편리한 유지보수와 시스템 운영의 용이성 제공</li>
                </ul>
              </div>
              <div className="epro-strength-box02 content-box epro-boxbar-y">
                <p className="color-primary fs-base fw-bold">업무 생산성 및 효율성 제고</p>
                <ul>
                  <li className="text-dot fs-base">고객 요구를 신속히 반영한 시스템 구축</li>
                  <li className="text-dot fs-base">고객 중심의 업무 환경 제공</li>
                  <li className="text-dot fs-base">프로세스 복잡도 해소로 업무 생산성 향상</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="epro-function">
        <div className="m-auto content-padding">
          <h3 className="content-title02">
            <strong>EPRO</strong> 주요 기능
          </h3>
          <p className="content-subtitle fs-md">
            내부 담당자를 위한 구매포털과 협력업체와의
            <br className="pc-none" /> 협업 기능을 위한 협력사포털로 구성
          </p>
          <div className="img-epro-function">
            <img src="./images/img-epro-function.svg" alt="epro-function-image" />
          </div>
          <div className="img-epro-function-mo">
            <img src="./images/img-epro-function-mo.svg" alt="uxboard-process" />
          </div>
        </div>
      </section>
      <section id="epro-effect">
        <div className="m-auto content-padding">
          <h3 className="content-title">
            <strong>EPRO</strong> 도입 기대효과
          </h3>
          <div className="epro-effect-container">
            <div className="epro-effect-box content-box epro-boxbar-x">
              <img src="./images/ico-epro-effect01.svg" alt="epro 기대효과 아이콘01" />
              <p className="color-primary fs-md fw-bold">저비용 · 고효율 효과 증대</p>
              <ul>
                <li className="fs-base">비대면 계약 진행으로 신속한 업무처리</li>
                <li className="fs-base">안정적/일관적/효율적 업무처리</li>
                <li className="fs-base">
                  모든 문서정보 DB화 및 전산화 처리
                  <br />
                  (견적/입찰 의뢰서/전자계약 작성, 조회 및 현황 확인)
                </li>
              </ul>
            </div>
            <div className="epro-effect-box content-box epro-boxbar-x">
              <img src="./images/ico-epro-effect02.svg" alt="epro 기대효과 아이콘02" />
              <p className="color-primary fs-md fw-bold">협력사 품지로간리 효과 증대</p>
              <ul>
                <li className="fs-base">협력사 평가관리/결과에 따른 우수업체 선정</li>
                <li className="fs-base">협력사와의 유기적인 관계성립 및 신뢰도 증가</li>
                <li className="fs-base">
                  협력사와의 정보공유 편의성 제공
                  <br />
                  (공지사항/게시판/FAQ 제공)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="epro-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img src="./images/logo-epro-white.svg" alt="epro-logo" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=epro&no=01" className="color-primary">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Epro;
